import * as React from 'react';
import DrawdownBox from '../DrawdownBox/DrawdownBox';

export interface BreakDownProps {
  planned: ResultsTable;
  current: ResultsTable;
  yearsFromDeath: string;
  lifeExpectancy: string;
}

interface ResultsTable {
  amount: string;
  percentage: string;
  willLast: string;
  whenYouAre: string;
}

const BreakDown = ({
  planned,
  current,
  yearsFromDeath,
  lifeExpectancy,
}: BreakDownProps) => (
  <div className="breakdown">
    <div className="breakdown__graphs">
      <div className="breakdown__graphs--section">
        <DrawdownBox
          heading="Current income drawdown"
          type="you currently take:"
          income={current.amount}
          percent={current.percentage}
          timeframe={current.willLast}
          age={current.whenYouAre}
        />
      </div>
      <div className="breakdown__graphs--section arrow-icon-wrapper">
        <div className="arrow-icon">
          <div className="caret" />
        </div>
      </div>
      <div className="breakdown__graphs--section">
        <DrawdownBox
          heading="Planned income drawdown"
          type="you plan to take:"
          income={planned.amount}
          percent={planned.percentage}
          timeframe={planned.willLast}
          age={planned.whenYouAre}
        />
      </div>
    </div>
    <div className="summary-wrapper output-detail">
      <h3 className="output-detail__heading">If you make these changes</h3>
      <p className="output-detail__body">
        Based on your age, gender and where you live, your pension pot could run out <span className="highlight">{yearsFromDeath}</span> than your estimated life expectancy, which is <span className="highlight">{lifeExpectancy}</span> When your life expectancy is longer than the term your money is expected to last, you will need to rely on other sources of income.
      </p>
    </div>
  </div>
);

export default BreakDown;



// WEBPACK FOOTER //
// ./src/components/Outputs/BreakDown/BreakDown.tsx